import React from 'react';
import {
  Heading,
  VStack,
} from '@chakra-ui/react';
import InputField from './form/InputField';

const BusinessPresenceView = (): JSX.Element => {
  return (
    <fieldset>
      <legend>
        <Heading fontSize="2xl" mb={6}>Presence</Heading>
      </legend>
      <VStack spacing={5}>
        <InputField
          name="url"
          label="Website URL"
          optional
          placeholder="https://mybusiness.com"
        />

        <InputField
          name="facebookPage"
          label="Facebook Page"
          optional
          placeholder="facebook.com/yourpage"
        />

        <InputField
          name="instagramProfile"
          label="Instagram Profile"
          optional
          placeholder="@yourprofile"
          maxLength={128}
        />
      </VStack>
    </fieldset>
  );
};

export default BusinessPresenceView;
